import { createContext } from 'react';
import { useContextOrThrow } from "../../../../utils/hooks";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var NotesListContext = /*#__PURE__*/createContext(null);
export function NotesListProvider(_ref) {
  var children = _ref.children,
    onPrefillTemplate = _ref.onPrefillTemplate,
    noteType = _ref.noteType,
    noteForm = _ref.noteForm;
  return _jsx(NotesListContext.Provider, {
    value: {
      onPrefillTemplate: onPrefillTemplate,
      noteType: noteType,
      noteForm: noteForm
    },
    children: children
  });
}
export function useNotesListContext() {
  return useContextOrThrow(NotesListContext, 'NotesList must be rendered inside NotesListProvider');
}